import {Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {INITIAL_VALUES, NonUnionInitialValues} from '../tokens';
import {FormComponent} from "lf-at-theme";
import {LfStorage} from "@lightweightform/core";
import {reactionCommencementDate} from '../../common/form-reactions';
import { autorun } from "mobx"

@Component({
  selector: 'app-non-union-form',
  templateUrl: './non-union-form.component.html',
  styleUrls: ['./non-union-form.component.scss']
})
export class NonUnionFormComponent implements OnInit, AfterViewInit {

  @ViewChild('form') _lfForm: FormComponent;

  constructor(@Inject(INITIAL_VALUES) public initialValues: NonUnionInitialValues) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    autorun(() => {
      reactionCommencementDate(this._lfForm);
    })

  }

  showExtraAddressFields(address): boolean {
    return address.suite
      || address.postOfficeBox
      || address.district
      || address.countrySubEntity
      || address.otherLocalId;
  }
}
